import { createContext, useState, useMemo, useCallback } from 'react'
import { node } from 'prop-types'
import { useDispatch } from 'react-redux'
import { api } from 'api'
import * as SnackbarActions from '../global/snackbar/snackbar.actions'

export const apiKeyContext = createContext({})

export const ApiKeyProvider = ({ children }) => {
  const [byId, setById] = useState({})
  const dispatch = useDispatch()

  const getPublicApiKeys = useCallback(
    () =>
      api.get(`/api/v1/user/public-api`).then(({ data }) => {
        setById(prev => data.reduce((acc, row) => ({ ...acc, [row.id]: row }), prev))
        return data
      }),
    [],
  )

  const createPublicApiKey = useCallback(() =>
    api.post(`/api/v1/user/public-api`).then(({ data }) => {
      setById({ ...byId, [data.id]: data })
    }),
  )

  const revokeApiKey = useCallback(apiKey =>
    api
      .delete(`/api/v1/user/public-api/${apiKey.api_key}`)
      .then(() => {
        setById(prev => {
          const { [apiKey.id]: _omit, ...res } = prev
          return res
        })
        dispatch(
          SnackbarActions.showSnackbar({
            message: 'API Key deleted successfully',
            type: 'SUCCESS',
            duration: 5000,
          }),
        )
      })
      .catch(() => {
        dispatch(
          SnackbarActions.showSnackbar({
            message: 'API key failed to delete',
            type: 'ERROR',
            duration: 5000,
          }),
        )
      }),
  )

  const updatePublicApiKeys = newPublicApiKeys => {
    setById(newPublicApiKeys)
  }

  const value = useMemo(
    () => ({
      byId,
      getPublicApiKeys,
      createPublicApiKey,
      revokeApiKey,
      updatePublicApiKeys,
    }),
    [byId, getPublicApiKeys, createPublicApiKey, revokeApiKey, updatePublicApiKeys],
  )

  return <apiKeyContext.Provider value={value}>{children}</apiKeyContext.Provider>
}

ApiKeyProvider.propTypes = {
  children: node.isRequired,
}
